// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2VOCc","name":"ConsentHeader_name__1zJYc","birthday":"ConsentHeader_birthday__11dql","skeleton":"ConsentHeader_skeleton__42Vol"};